import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { CircleProgressComponent } from './circle-progress';

@NgModule({
  declarations: [
    CircleProgressComponent,
  ],
  imports: [
    IonicModule,
  ],
  exports: [
    CircleProgressComponent
  ]
})
export class CircleProgressComponentModule {}



// WEBPACK FOOTER //
// ./src/components/circle-progress/circle-progress.module.ts